// extracted by mini-css-extract-plugin
module.exports = {"root":"HeaderPlaceholder-module--root--OqJJ2","half":"HeaderPlaceholder-module--half--1ulde"};